import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0849788d")

_pushScopeId("data-v-0849788d")
const _hoisted_1 = {
  key: 0,
  class: "badge"
}
const _hoisted_2 = { class: "ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")

  return (_openBlock(), _createBlock("div", {
    class: ["button-selection", { disabled: _ctx.disabled, active: _ctx.localValue }],
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleValue()))
  }, [
    (_ctx.localValue)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_InlineSvgScoped, {
            src: require(`@/assets/images/icon-check.svg`),
            "aria-label": "icon-blueprint"
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InlineSvgScoped, {
      src: _ctx.icon,
      "aria-label": "icon-blueprint"
    }, null, 8, ["src"]),
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
  ], 2))
})